import { Component, Inject } from "@angular/core";
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, SimpleSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
})
export class NotificationComponent extends SimpleSnackBar {
  public cssPrefix: string;

  constructor(public snackBarRef: MatSnackBarRef<NotificationComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: any) {
    super(snackBarRef, data);
    this.cssPrefix = data.cssPrefix;
  }

  action(): void {
    this.snackBarRef.dismiss();
  }
}
